import { BaseText } from 'slate';
import { RenderLeafProps } from 'slate-react';

import styles from './CustomLeaf.module.scss';

type FormattedText = BaseText & {
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
};

const isFormattedText = (node: BaseText): node is FormattedText => {
  return typeof node.text === 'string';
};

const CustomLeaf = (props: RenderLeafProps) => {
  const { attributes, children, leaf } = props;

  if (!isFormattedText(leaf)) {
    return <span {...attributes}>{children}</span>;
  }

  let formattedChildren = children;

  if (leaf.bold) {
    formattedChildren = <strong>{formattedChildren}</strong>;
  }
  if (leaf.italic) {
    formattedChildren = <em>{formattedChildren}</em>;
  }
  if (leaf.underline) {
    formattedChildren = <u>{formattedChildren}</u>;
  }

  return (
    <span className={styles.content} {...attributes}>
      {formattedChildren}
    </span>
  );
};

export default CustomLeaf;
